// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ContentComponentItemFragmentDoc } from '../../../../components/cms/component/ContentComponentItem.fragment.generated';
export const EngagementRingStoneRecommendationCardFragmentDoc = gql`
    fragment engagementRingStoneRecommendationCard on EngagementRingStoneRecommendationCard {
  __typename
  title
  description
  notSupportedContent {
    ...contentComponentItem
  }
  notFoundContent {
    ...contentComponentItem
  }
}
    ${ContentComponentItemFragmentDoc}`;